import AssignmentIcon from "@mui/icons-material/Assignment";
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography } from "@mui/material";
import { useState } from "react";
import { wrapFormikHandleChange } from "../../../infrastructure/utils/formatters";
import DropdownPicker from "../shared/dropdown";
import JalaliDatePicker from "../shared/jalali-datepicker";
import JalaliDateTimePicker from "../shared/jalali-datetimepicker";
import FileUploader from "../shared/uploader/FileUploader";
import MapViewer from "../map/MapViewer";

const FormItem = ({
  form,
  values,
  inputProps,
  handleChange,
  setFieldValue,
  handleBlur,
  onButtonClick, // برای دکمه‌های سفارشی
  baseUrl, // برای نمایش فایل‌های آپلود شده
}) => {
  const {
    type = "input",
    // isRequired = false,
    // isRequiredText,
    isVisible = true,
    isReadonly = false,
    label = "عنوان",
    key,
    filterByKey = null,
    options = null,
  } = form;


  // type: "date" | "select" | "input" | "upload";
  //  options?: { value: string; label: string,filterKey?:string }[];

    if (type === "input" || type === "number") {
    return (
      <TextField
        label={label}
        onChange={wrapFormikHandleChange(handleChange)}
        type={type === "number" ? "number" : "text"}
        {...inputProps}
        disabled={isReadonly || !isVisible}
        onBlur={handleBlur}
      />
    );
  }

  if (type === "date") {
    return (
      <JalaliDatePicker
        label={label}
        onChange={(value) => {
          setFieldValue(key, value);
        }}
        {...inputProps}
        disabled={isReadonly || !isVisible}
        onBlur={handleBlur}
      />
    );
  }

  if (type === "datetime") {
    return (
      <JalaliDateTimePicker
        label={label}
        onChange={(value) => {
          setFieldValue(key, value);
        }}
        {...inputProps}
        disabled={isReadonly || !isVisible}
        onBlur={handleBlur}
      />
    );
  }

  if (type === "select") {
    return (
      <DropdownPicker
        label={label}
        onChange={(event) => {
          setFieldValue(key, event.target.value);
        }}
        {...inputProps}
        list={options}
        filterable={true}
        disabled={isReadonly || !isVisible}
        optionName="label"
        optionValue="value"
        onBlur={handleBlur}
      />
    );
  }

  if (type === "checkbox") {
    return (
      <FormControlLabel
        control={<Checkbox checked={inputProps?.value || false} />}
        label={label}
        onChange={(event) => {
          setFieldValue(key, event.target.checked);
        }}
        {...inputProps}
        disabled={isReadonly || !isVisible}
      />
    );
  }

  if (type === "upload" || type === "file") {
    return (
      <FileUploader
        moduleName={"SLN/CustomerData"}
        maxFiles={1}
        label={label}
        onChange={(value) => {
          // FileUploader می‌تواند string یا array برگرداند
          // اگر array است، اولین عنصر را می‌گیریم، وگرنه خود value را
          const finalValue = Array.isArray(value) ? (value.length > 0 ? value[0] : "") : (value || "");
          setFieldValue(key, finalValue);
        }}
        baseUrl={baseUrl}
        placeholder={isReadonly ? "فایل آپلود شده" : "فایل را انتخاب کنید"}
        accept="image/*"
        {...inputProps}
        disabled={isReadonly || !isVisible}
      />
    );
  }

  // فیلد نمایش روش پرداخت انتخاب شده
  if (type === "payment-display") {
    return (
      <TextField
        label={label}
        value={values[key] || ""}
        fullWidth
        InputProps={{
          readOnly: true,
        }}
        disabled
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: "#f5f5f5",
          },
        }}
      />
    );
  }

  // تغییر contractor-selector برای نمایش عنوان انتخاب شده
  if (type === "contractor-selector") {
    const selectedValue = values[key];
    
    if (selectedValue) {
      // اگر مقداری انتخاب شده است
      return (
        <div style={{ display: "flex", gap: "8px", flexDirection: "column" }}>
          <TextField
            label={label}
            value={selectedValue}
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            disabled
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#e3f2fd",
              },
            }}
          />
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            startIcon={<AssignmentIcon />}
            onClick={() => onButtonClick?.(key)}
            disabled={isReadonly || !isVisible}
            sx={{ height: 40 }}
          >
            تغییر انتخاب
          </Button>
        </div>
      );
    }
    
    // اگر هنوز مقداری انتخاب نشده است
    return (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        startIcon={<AssignmentIcon />}
        onClick={() => onButtonClick?.(key)}
        disabled={isReadonly || !isVisible}
        sx={{ height: 56 }}
      >
        {label}
      </Button>
    );
  }
  
  
  if (type === "payment-selector") {
    const selectedValue = values[key];
    
    if (selectedValue) {
      // اگر مقداری انتخاب شده است
      return (
        <div style={{ display: "flex", gap: "8px", flexDirection: "column" }}>
          <TextField
            label={label}
            value={selectedValue}
            fullWidth
            InputProps={{
              readOnly: true,
            }}
            disabled
            sx={{
              "& .MuiOutlinedInput-root": {
                backgroundColor: "#fff3e0", // نارنجی روشن
              },
            }}
          />
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            startIcon={<AssignmentIcon />}
            onClick={() => onButtonClick?.(key)}
            disabled={isReadonly || !isVisible}
            sx={{ height: 40 }}
          >
            تغییر انتخاب
          </Button>
        </div>
      );
    }
    
    // اگر هنوز مقداری انتخاب نشده است
    return (
      <Button
        variant="contained"
        color="primary"
        fullWidth
        startIcon={<AssignmentIcon />}
        onClick={() => onButtonClick?.(key)}
        disabled={isReadonly || !isVisible}
        sx={{ height: 56 }}
      >
        {label}
      </Button>
    );
  }

  if (type === "map") {
    const xPoint = values.XPoint || values.xPoint;
    const yPoint = values.YPoint || values.yPoint;

    return (
      <MapViewer
        xPoint={xPoint}
        yPoint={yPoint}
        label={label || "مشاهده موقعیت روی نقشه"}
        dialogTitle={label || "موقعیت روی نقشه"}
        showButton={true}
      />
    );
  }

  if (type === "textarea") {
    return (
      <TextField
        label={label}
        onChange={wrapFormikHandleChange(handleChange)}
        multiline
        rows={4}
        {...inputProps}
        disabled={isReadonly || !isVisible}
        onBlur={handleBlur}
      />
    );
  }

  // اگر type مشخص نیست، null برگردان تا چیزی نمایش داده نشود
  return null;
};

export default FormItem;
